import { useQuery } from '@tanstack/react-query'
import { referralsApi } from './referrals'
import { queryKeys } from './query-keys'

/** The advisor's referred consumers, newest movement first (mock-only). */
export function useReferrals(userId: number | string | null | undefined) {
  return useQuery({
    queryKey: queryKeys.referrals.byAdvisor(userId ?? 'none'),
    queryFn: () => referralsApi.byAdvisor(Number(userId)),
    enabled: userId != null,
  })
}
